import React, { useEffect, useState, useRef } from "react";
import "./GlobalContactSearchResultsTable.css";
import { useGlobalContactSearchState } from "./GlobalContactSearchStateContext";
import GenericTable from "../genericComponents/genericTableComp/GenericTable";
import PreSearchComp from "../genericComponents/uiElements/PreSearchComp";
import { formatNumberInternational, formatShortNumber, pxToRem, userAuthorized } from "../../../utilities/uiUtils";
import { appendContactToFilter, enrichContactV2, getCreditBalance, saveGlobalContactsInList } from "../../../services/iqApiV2";
import AccessField from "../AccountDetails/Opportunities/accessEmailComp/AccessField";
import { useUser } from "../../../context/UserContext";
import AccessPhoneButton from "../AccountDetails/Opportunities/accessEmailComp/AccessPhoneField";
import TextWithTooltip from "./TextWithTooltip";
import SaveToListModal from "./SaveToListModal";
import SimpleThemedButton from "../genericComponents/simpleTextField/SimpleThemedButton";
import GenericOverviewSideCard from "../genericComponents/GenericOverviewSideCard";
import ScHeaderComp from "../genericComponents/genericTableComp/genericTableScHeader/ScHeaderComp";
import GlobalContactAutoNurtureContainer from "./globalContactAutoNurture/GlobalContactAutoNurtureContainer";
import IOSSpinner from "../../HtmlElements/IOSSpinner";
import { useBanner } from "../../../context/BannerContext";
import { CopyLineDuotone } from "../../../svgs/CopyLineDuotone";
import StatusIndicator from "../genericComponents/resizeableTable/StatusIndicator";
import { addStreamListener, initStreamSW, startPhoneStream } from "../../../streaming/streamSwClient";
import GenericTagComp from "../genericComponents/tag/GenericTagComp";
import TextTooltipOnly from "./TextTooltipOnly";
import { Info } from "react-feather";
import GenericFloatingBanner from "../genericComponents/uiElements/GenericFloatingBanner";

function GlobalContactSearchResultsTable({ initialListItems, postOnSave = async () => { } }) {
  const {
    domains,
    jobTitle,
    seniorities,
    personLocations,
    contactEmailStat,
    orgHeadCount,
    orgRevenue,
    searchedContacts,
    setSearchedContacts,
    page,
    rowsPerPage,
    setRowsPerPage,
    setpage,
    searchContactLoading,
    totalEntires,
  } = useGlobalContactSearchState();
    const [banner, setBanner] = useState(null);
  
    const triggerBanner = ({ message, type = "info", duration = 4000 }) => {
      setBanner({
        id: Date.now(),
        message,
        type,
        duration,
        title:""
      });
    };
  const buildSearchObj = () => ({
    contact_email_status: contactEmailStat,
    page: page,
    per_page: rowsPerPage,
    person_locations: personLocations,
    person_seniorities: seniorities,
    revenue_range: orgRevenue,
    domains: domains,
    job_Title: jobTitle,
    org_Head_Count: orgHeadCount
  });
  const [contactsSaving, setContactsSaving] = useState(false)
  const [contactLists, setContactLists] = useState([]);

  const prepareSaveListObj = (listObj) => {

    // 1) Get initial contacts for this list (if exists)
    const existingList = initialListItems.find(item => item.id === listObj.id);
    const existingContacts = existingList?.contacts || [];

    // 2) Convert selectedRows into map by ID for quick lookup
    const selectedContactMap = Object.fromEntries(
      selectedRows.map(c => [c.id, c])
    );

    // 3) Merge logic:
    // - If existing contact appears in selectedRows → update it
    // - Else keep as is
    const mergedContacts = existingContacts.map(oldContact => {
      if (selectedContactMap[oldContact.id]) {
        // update old contact with fresh selected data
        return {
          ...oldContact,
          ...selectedContactMap[oldContact.id]
        };
      }
      return oldContact;
    });

    // 4) Append NEW contacts that do not exist in existingContacts
    const existingIds = new Set(existingContacts.map(c => c.id));
    selectedRows.forEach(sel => {
      if (!existingIds.has(sel.id)) {
        mergedContacts.push(sel); // append new
      }
    });

    // 5) Base payload
    const base = {
      user_id: user?.id,
      name: listObj?.name,
      selected_contacts: selectedRows.map(row => row.id),
      filters: {
        additionalProp1: {
          ...buildSearchObj(),
          contacts: mergedContacts   // <-- send merged here
        }
      }
    };

    // 6) Only add update_existing_id for actual lists (not temp)
    if (!String(listObj?.id)?.trim()?.startsWith("temp-")) {
      base.update_existing_id = listObj.id;
    }

    return base;
  };


  useEffect(() => {
    setContactLists(initialListItems)
  }, [initialListItems])



  const [selectedRows, setSelectedRows] = useState([])
  const [tabData, setTabData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const { user } = useUser();
  const [showListModal, setShowListModal] = useState(false);
  const [nurtureSideCardOpen, setNurtureSidecardOpen] = useState(false)
  const copyToClipboard = (text, type = "email") => {
    navigator.clipboard.writeText(text)
      .then(() => {

        triggerBanner({
          message: type === "phone" ? "Phone Number Copied Successfully" : "Email Copied Successfully",
          type: "success",
          duration: 10000,
        });
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  };

  const handleOnAccessEmailClick = async (e, userId, apolloId, phoneAccess = false) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      const requiredCredits = phoneAccess ? 10 : 2;
      const balance = await getCreditBalance(userId);
      if (balance < requiredCredits) {
        // Show banner if insufficient credits

        triggerBanner({
          message: `Insufficient credits to ${phoneAccess ? "access phone" : "access email"
            }. Please recharge to continue.`,
          type: "warning",
          duration: 10000,
        });
        return;
      }
      const resp = await enrichContactV2(userId, apolloId, phoneAccess, () => { }, () => { });

      if (phoneAccess) {
        const key = `${user.id}_${apolloId}_phone_pending`;
        localStorage.setItem(key, JSON.stringify({
          ts: Date.now()
        }));
        startPhoneStream(apolloId);
      }

      let updatedEmail = resp?.email;
      const updatedPhone = resp?.phone;
      if (!updatedEmail && !phoneAccess) {
        updatedEmail = "Not Found";
        triggerBanner({
          message: "No Email Found. Try after some time.",
          type: "warning",
          title:"Alert",
          duration: 10000,
        });
        // return; // stop further state updates
      }
      console.log("updatedEmail", updatedEmail);
      console.log("updatedPhone", updatedPhone);

      // 🔥 This WILL survive outside of setState
      let updatedObjFinal = null;

      // FIRST calculate updated contact
      setSearchedContacts((prev) => {
        const updated = prev?.map((item) => {
          if (item.id === apolloId) {
            updatedObjFinal = {
              ...item,
              ...(phoneAccess
                ? { phone: updatedPhone }   // 🔥 update phone only
                : { email: updatedEmail }   // 🔥 update email only
              ),
            };
            return updatedObjFinal;
          }
          return item;
        });
        return updated;
      });

      // Wait microtask so state callback executes
      await Promise.resolve();

      if (!updatedObjFinal) {
        console.error("❌ updatedObjFinal is NULL — update failed");
        return;
      }

    } catch (err) {
      console.error("Failed to enrich contact:", err);
    }
  };



  const tableColumns = [
    { id: "generic-check-box", width: "1rem" },
    { id: "contactName", label: "Name", width: 100, clickAction: true, alignment: "flex-start" },
    { id: "domains", label: "Organization", width: 90, alignment: "flex-start" },
    { id: "location", label: "Location", width: 90, alignment: "flex-start" },
    { id: "linkedinUrl", label: "LinkedIn", width: 40, alignment: "flex-start" },
    {
      id: "emailAccess",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          Email
          <TextTooltipOnly
            text="Emails consume 2 credits. Results are instant." // Tooltip content for email access
            // className="info-icon"
            placement="top"
          >
            <Info size={12} style={{ opacity: 0.6, cursor: "pointer" }} />
          </TextTooltipOnly>
        </div>
      ),
      width: 80,
      alignment: "center",
    },
    {
      id: "phoneAccess",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          Phone
          <TextTooltipOnly
            text="Phone numbers consume 10 credits. Results in 3–5 minutes" // Tooltip content for phone access

            placement="top"
          >
            <Info size={12} style={{ opacity: 0.6, cursor: "pointer" }} />
          </TextTooltipOnly>
        </div>
      ),
      width: 80,
      alignment: "center",
    },



  ];

  useEffect(() => {
    let removeListener = null;

    const setup = async () => {
      try {
        await initStreamSW(); // ensure SW is ready

        removeListener = addStreamListener((msg) => {
          if (msg.type === "PHONE_UPDATE") {
            const key = `${user?.id}_${msg.apolloId}_phone_pending`;
            localStorage.removeItem(key)
            setSearchedContacts((prev) =>
              prev.map((c) =>
                c.id === msg.apolloId ? { ...c, phone: msg.phone } : c
              )
            );
          }
          if (msg.type === "PHONE_UPDATE_ERROR") {
            const key = `${user?.id}_${msg.apolloId}_phone_pending`;
            localStorage.removeItem(key)
            setSearchedContacts((prev) =>
              prev.map((c) =>
                c.id === msg.apolloId ? { ...c, phone: "Not Found" } : c
              )
            );
            console.log("No phone found:", msg.message);
          }
        });
      } catch (err) {
        console.error("Stream SW init failed:", err);
      }
    };

    setup();

    return () => {
      if (typeof removeListener === "function") {
        removeListener(); // safely remove listener
      }
    };
  }, []);



  useEffect(() => {

    if (user?.id) {
      if (!searchedContacts) return;

      const query = searchQuery.trim().toLowerCase();
      let filtered = searchedContacts;

      if (query) {
        filtered = searchedContacts.filter((item) => {
          const name = item?.name?.toLowerCase() || "";
          const title = item?.title?.toLowerCase() || "";
          const city = item?.city?.toLowerCase() || "";
          const state = item?.state?.toLowerCase() || "";
          const country = item?.country?.toLowerCase() || "";
          const domain = item?.domains?.toLowerCase() || "";
          return (
            name.includes(query) ||
            title.includes(query) ||
            city.includes(query) ||
            state.includes(query) ||
            country.includes(query) ||
            domain.includes(query)
          );
        });
      }

      const enhanced = filtered.map((item) => {

        const key = `${user?.id}_${item?.id}_phone_pending`;
        const pendingEntry = localStorage.getItem(key);

        let isPhonePending = false;

        if (pendingEntry) {
          const { ts } = JSON.parse(pendingEntry);

          const oneHour = 60 * 60 * 1000;
          const expired = Date.now() - ts > oneHour;

          if (expired) {
            localStorage.removeItem(key);
          } else {
            isPhonePending = true;
          }
        }

        if (item?.phone && item?.phone !== "Not Found" && item?.phone.trim() !== "") {
          isPhonePending = false;
          localStorage.removeItem(key);
        }

        return {
          ...item,
          id: item?.id,

          contactName: (
            <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", width: "100%" }}>
              <TextWithTooltip
                className="single-line-ellipse_gcsrt"
                text={item?.name}
              />
              <TextWithTooltip text={item?.title} className="enhancerows_gcsrt" />
            </div>
          ),
          location: (
            <TextWithTooltip
              text={[item?.city, item?.state, item?.country]
                .filter(Boolean)
                .join(", ")}
              className="enhancerows_gcsrt"
            />
          ),
          domains: (
            <>
              {item?.organization ? (
                <a
                  href={item.organization.website_url || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    textDecoration: "none",
                    color: "inherit",
                    gap: "8px",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    const website = item.organization.website_url;
                    if (website) {
                      const url = website.startsWith("http")
                        ? website
                        : `https://${website}`;
                      window.open(url, "_blank", "noopener,noreferrer");
                    }
                  }}
                >
                  {item.organization.logo_url && (
                    <img
                      src={item.organization.logo_url}
                      alt={`${item.organization.name || "Company"} logo`}
                      style={{
                        width: "20px",
                        height: "20px",
                        objectFit: "contain",
                        borderRadius: "4px",
                      }}
                    />
                  )}
                  <TextWithTooltip
                    text={item.organization.name || "Unknown Organization"}
                    className="enhancerows_gcsrt_org"
                  />
                </a>
              ) : (
                item?.account?.domain || item?.account?.primary_domain || "-"
              )}
            </>
          ),
          linkedinUrl: item?.linkedin_url ? (
            <a
              href={item.linkedin_url || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className="scrc-linkedin"
              title="View on LinkedIn"
              onClick={(e) => {
                e.preventDefault();
                if (item.linkedin_url) {
                  const url = item.linkedin_url.startsWith("http")
                    ? item.linkedin_url
                    : `https://${item.linkedin_url}`;
                  window.open(url, "_blank", "noopener,noreferrer");
                }
              }}
            >
              <i className="fa fa-linkedin-square" aria-hidden="true"></i>
            </a>
          ) : (
            "-"
          ),
          emailAccess: item?.email === "Not Found" ? (
            <span className="access_mob_text_show">
              <GenericTagComp
                color={"red"}
                onChipClick={() => { }}
                text={"Not Found"}
              />
            </span>
          ) : (
            <AccessField
              field_value={item?.email}
              onAccessClick={(e) =>
                handleOnAccessEmailClick(e, user?.id, item?.id, false)
              }
              showCopyButton={true}
              copyToClipboard={copyToClipboard}
            />
          ),
          phoneAccess: (
            isPhonePending ? (
              <StatusIndicator text="Fetching Number" />
            ) : item?.phone === "Not Found" ? (
              <span className="access_mob_text_show"><GenericTagComp color={"red"} onChipClick={() => { }} text={"Not Found"} /></span>
            ) : (
              <AccessPhoneButton
                phone={item?.phone}
                onAccessClick={(e) =>
                  handleOnAccessEmailClick(e, user?.id, item?.id, true)
                }
                showCopyButton={true}
                copyToClipboard={(value) => copyToClipboard(value, "phone")}
              />
            )
          )
          ,

          noProcessedItem: item,
        };
      });

      setTabData(enhanced);

    }
  }, [searchedContacts, page, rowsPerPage, searchQuery, user?.id]);



  return (
    <div className="gcsrt-container" style={{ width: pxToRem(1500) }}>
             {banner && (
              <GenericFloatingBanner
                key={banner.id}
                message={banner.message}
                title={banner.title}
                type={banner.type}
                duration={banner.duration}
                onClose={() => setBanner(null)}
              />
            )}
      {!totalEntires && !searchContactLoading ? (
        <PreSearchComp />
      ) : (
        <>
          {/* <div className="gcsrt-container-table-top" style={{
            display: "flex",
            justifyContent: "flex-end", // pushes text to right
            alignItems: "center",
          }}>
            <span
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                fontSize: "12.8px",
                marginBottom: "4px",
               
              }}
            >
              &nbsp;&nbsp;Total {formatShortNumber(totalEntires)} 
            </span>
          </div> */}
          <div
            className="gcsrt-container-table-top"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0.5rem",
              height: "2rem",
            }}
          >
            <div
              style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                gap: "1.5rem",
              }}
            >
              {selectedRows.length > 0 && (
                <>
                  <div
                    style={{
                      fontSize: "12.8px",
                      cursor: "pointer",
                    }}
                    onClick={() => setSelectedRows([])}
                  >
                    Clear Selected ({selectedRows.length})
                  </div>
                  <div className="save-list-btn-wrapper">
                    {contactsSaving ? <IOSSpinner /> : <button
                      style={{
                        fontSize: "12.8px",
                        padding: "4px 8px",
                        border: "none",
                        borderRadius: "4px",
                        backgroundColor: "#e4edf7ff",
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowListModal(true);
                      }}
                    >
                      Save To List
                    </button>}
                    {showListModal && (
                      <SaveToListModal
                        contactLists={contactLists}
                        setContactLists={setContactLists}
                        show={showListModal}
                        onClose={async () => { setShowListModal(false) }}
                        onSave={async (selectedLists) => {
                          try {
                            setContactsSaving(true);
                            console.log(
                              "selectedLists",
                              initialListItems,
                              selectedLists
                            );

                            const payloads = selectedLists.map((listObj) =>
                              prepareSaveListObj(listObj)
                            );

                            console.log(
                              "Payloads to send to backend:",
                              payloads
                            );

                            // Run all API calls in parallel and wait for all of them
                            await Promise.all(
                              payloads.map((element) =>
                                saveGlobalContactsInList(element)
                              )
                            );

                            // Call only after ALL list saves are complete
                            await postOnSave();

                            initialListItems = { initialListItems };

                            setShowListModal(false);
                            setSelectedRows([]);

                            triggerBanner({
                              message: "Saved To List",
                              type: "success",
                              duration: 10000,
                            });
                          } catch (error) {

                            triggerBanner({
                              message: "Unexpected Error",
                              type: "error",
                              duration: 10000,
                            });

                          } finally {
                            setContactsSaving(false);
                          }

                        }}
                      />
                    )}
                  </div>
                </>
              )}
            </div>

            {/* Always right-aligned */}
            <div
              style={{
                flexShrink: 0,
                fontSize: "0.9rem",
                fontWeight: "500",
                textAlign: "right",
                display: "flex",
                flexDirection: "row",
                gap: "1rem",
                alignItems: "center",
              }}
            >
              {!searchContactLoading ? (
                <>
                  <span>Total {formatNumberInternational(totalEntires)}</span>

                  {userAuthorized?.includes(user?.email) && totalEntires <= 1000 && (
                    <SimpleThemedButton
                      title={"Auto Nurture"}
                      buttonText="Auto Nurture"
                      onBtnClick={() => setNurtureSidecardOpen(true)}
                    />
                  )}
                </>
              ) : (
                <IOSSpinner />
              )}
            </div>
          </div>

          <GenericTable
            disableSort={true}
            allowSelection={true}
            enablePagination={true}
            currentPage={page}
            itemsPerPage={rowsPerPage}
            totalItems={totalEntires}
            initialColumns={tableColumns}
            tabData={tabData}
            onPageChange={setpage}
            onRowsPerPageChange={null}
            loading={searchContactLoading}
            oppName={null}
            loadingRows={15}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />

          <GenericOverviewSideCard
            titleForSideCard={
              <>
                <ScHeaderComp
                  key={`side_card_head_comp_auto_nurture_global_contact_find`}
                  type="auto_nurture"
                  // opportunityId={commonProps?.opportunityId}
                  // data={currRow}
                  titlkey={"Auto Nurture"}
                  titlTxt={" "}
                  setShowMoreModal={setNurtureSidecardOpen}
                // activeTab={activeTab}
                />
              </>
            }
            showMoreModal={nurtureSideCardOpen}
            setShowMoreModal={setNurtureSidecardOpen}
            comp={
              <>
                <GlobalContactAutoNurtureContainer
                  setNurtureSidecardOpen={setNurtureSidecardOpen}
                />
              </>
            }
            minWidthForDrawer="60%"
            disableXbtn
            preserveState={false}
          />
        </>
      )}
    </div>
  );
}

export default GlobalContactSearchResultsTable;


